import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './component/home/home.component';
import { EnrolRouteGuard } from './utility/configuration/route-gurads/enrol-route-guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth',
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./feature-module/auth/auth.module').then((mod) => mod.AuthModule),
  },
  {
    path: 'product',
    loadChildren: () =>
      import('./feature-module/product/product.module').then(
        (mod) => mod.ProductModule
      ),
  },
  {
    path: 'investigation-queue',
    loadChildren: () =>
      import(
        './feature-module/investigation-queue/investigation-queue.module'
      ).then((mod) => mod.InvestigationQueueModule),
  },
  {
    path: 'reporting',
    loadChildren: () =>
      import(
        './feature-module/reporting/reporting.module'
      ).then((mod) => mod.ReportingModule),
      canActivate: [EnrolRouteGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
